import { Entry } from '../Entry'

export function Entry20220629() {
  return (
    <Entry title="29/06/2022 - v3.0.13">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12664/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
